var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcNewWindow = function SvgIcNewWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.569.96a.75.75 0 0 0 0 1.5h1.766L5.943 8.852a.75.75 0 0 0 1.061 1.06l6.544-6.544V5.44a.75.75 0 0 0 1.5 0V1.71a.75.75 0 0 0-.75-.75h-3.73ZM2.71 3.858a.25.25 0 0 0-.25.25v9.19c0 .137.112.25.25.25H11.9a.25.25 0 0 0 .25-.25V9.634a.75.75 0 0 1 1.5 0v3.662a1.75 1.75 0 0 1-1.75 1.75H2.71a1.75 1.75 0 0 1-1.75-1.75V4.108c0-.966.784-1.75 1.75-1.75h3.663a.75.75 0 0 1 0 1.5H2.71Z"
  })));
};
export default SvgIcNewWindow;